export * from "@/ui/components/typography/TextHero";
export * from "@/ui/components/typography/TextTitle";
export * from "@/ui/components/typography/TextBody";
export * from "@/ui/components/typography/TextSubtitle";
